import { isLocalStorageAvailable } from '../../../../utils';

const GETTERS = {
  GET_FILTERED_ARRAY: state => array => {
    let filteredArray = array;
    let filters = [...state.constantFilters, ...state.filters];
    for (let filter of filters) {
      filteredArray = filteredArray.filter(element => {
        let { property, from, to, equal } = filter;
        from = Number(from);
        to = Number(to);

        if (to && from) {
          return element[property] >= from && element[property] <= to;
        } else if (to) {
          return element[property] <= to;
        } else if (from) {
          return element[property] >= from;
        } else if (equal) {
          for (let amenity of element.amenities) {
            if (amenity == property) {
              return true;
            }
          }
          return element[property] == equal;
        }

        return true;
      });
    }
    return filteredArray;
  },
  GET_SORTED_ARRAY: state => array => {
    let flats = array;
    let { property, order } = state.sorting;
    return flats.sort((a, b) => {
      if (
        property == state.flatProperties['id'] ||
        property == state.flatProperties['type']
      ) {
        if (a[property].length != b[property].length) {
          return (a[property].length - b[property].length) * order;
        }

        if (a[property] < b[property]) {
          return 1 * order;
        }
        if (a[property] > b[property]) {
          return -1 * order;
        }
      }

      if (property == state.flatProperties['status']) {
        switch (a[property]) {
          case state.flatProperties['status_available']:
            return -1 * order;
          case state.flatProperties['status_reserved']:
            return 1 * order;
          default:
            return 0;
        }
      }

      return (Number(b[property]) - Number(a[property])) * order;
    });
  },
  GET_FLATS: state => {
    return state.flats;
  },
  GET_FLATS_BY_PROPERTY: state => (property, value) => {
    return state.flats.filter(flat => flat[property] == value);
  },
  GET_FLATS_BY_FLOOR: (state, getters) => floor => {
    return getters.GET_FLATS_BY_PROPERTY(state.flatProperties['floor'], floor);
  },
  GET_FILTERED_FLATS: (state, getters) => {
    return getters.GET_FILTERED_ARRAY(state['flats']);
  },
  GET_FILTERED_FLATS_BY_FLOOR: (state, getters) => floor => {
    return getters.GET_FILTERED_ARRAY(getters.GET_FLATS_BY_FLOOR(floor));
  },
  GET_FILTERED_FLATS_BY_BUILDING: (state, getters) => building => {
    return getters.GET_FILTERED_ARRAY(
      getters.GET_FLATS_BY_PROPERTY(state.flatProperties['building'], building)
    );
  },
  GET_FILTERED_FLATS_BY_BUILDING_AND_FLOOR: (state, getters) => (
    building,
    floor
  ) => {
    return getters.GET_FILTERED_ARRAY(
      state.flats.filter(flat => {
        // console.log(flat);
        return (
          flat[state.flatProperties['building']] == building &&
          flat[state.flatProperties['floor']] == floor
        );
      })
    );
  },
  GET_SORTED_FLATS: (state, getters) => () => {
    return getters.GET_SORTED_ARRAY(getters.GET_FLATS);
  },
  GET_SORTED_AND_FILTERED_FLATS: (state, getters) => () => {
    return getters.GET_SORTED_ARRAY(getters.GET_FILTERED_FLATS);
  },
  GET_SORTED_AND_FILTERED_FLATS_BY_FLOOR: (state, getters) => (
    floor,
    property,
    type
  ) => {
    return getters.GET_SORTED_ARRAY(
      getters.GET_FILTERED_FLATS_BY_FLOOR(floor),
      property,
      type
    );
  },
  IS_FAVOURITE: (state, getters) => flat => {
    if (flat && flat[state.flatProperties['id']]) {
      let ids = getters.GET_FAVOURITES.map(
        fav => fav[state.flatProperties['id']]
      );
      return ids.includes(flat[state.flatProperties['id']]);
    }

    return false;
  },
  GET_FAVOURITES: state => {
    if (isLocalStorageAvailable()) {
      if (state.favourites.length == 0 && localStorage.favourites) {
        return JSON.parse(localStorage.favourites);
      }
    }
    return state.favourites;
  },
  GET_FILTERED_FAVOURITES: (state, getters) => {
    return getters.GET_FILTERED_ARRAY(state['favourites']);
  },
  GET_SORTED_FAVOURITES: (state, getters) => (property, type) => {
    return getters.GET_SORTED_ARRAY(getters.GET_FAVOURITES, property, type);
  },
  GET_SORTED_AND_FILTERED_FAVOURITES: (state, getters) => (property, type) => {
    return getters.GET_SORTED_ARRAY(
      getters.GET_FILTERED_FAVOURITES,
      property,
      type
    );
  },
  GET_CURRENT_FLAT: (state, getters, rootState) => {
    let results = getters.GET_FLATS_BY_PROPERTY(
      state.flatProperties['id'],
      rootState.route.params.flat
    );

    if (results.length) {
      return results[0];
    }

    return null;
  },
  GET_SIMILAR_FLAT: (state, getters, rootState, rootGetter) => (
    flat,
    quantity
  ) => {
    // console.log(state);
    let flats = [...getters.GET_FLATS];
    let similars = [];

    flats = flats.filter(({ status_id }) => Number(status_id) !== 3);

    for (let j = 0; j < quantity; j++) {
      let min = 0;
      let minValue = 0;
      for (let i in flats) {
        let differences = 0;
        differences += Math.abs(
          flat[state.flatProperties['floor']] -
            flats[i][state.flatProperties['floor']]
        );
        differences += Math.abs(
          flat[state.flatProperties['rooms']] -
            flats[i][state.flatProperties['rooms']]
        );
        differences += Math.abs(
          flat[state.flatProperties['area']] -
            flats[i][state.flatProperties['area']]
        );

        if (i == 0) {
          while (
            rootGetter.GET_STATUS_NAME(
              flats[i][state.flatProperties['status']]
            ) == 3 ||
            flats[i][state.flatProperties['id']] ==
              flat[state.flatProperties['id']]
          ) {
            i++;
          }
          min = i;
          minValue = differences;
        } else if (
          differences < minValue &&
          rootGetter.GET_STATUS_NAME(
            flats[i][state.flatProperties['status']]
          ) != 3 &&
          flats[i][state.flatProperties['id']] !=
            flat[state.flatProperties['id']]
        ) {
          min = i;
          minValue = differences;
        }
      }
      similars.push(flats[min]);
      flats.splice(min, 1);
    }
    return similars;
  },
};

export default GETTERS;
